import { render, staticRenderFns } from "./FloatingSlotCard.vue?vue&type=template&id=586f4a5c&scoped=true"
import script from "./FloatingSlotCard.vue?vue&type=script&lang=js"
export * from "./FloatingSlotCard.vue?vue&type=script&lang=js"
import style0 from "./FloatingSlotCard.vue?vue&type=style&index=0&id=586f4a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586f4a5c",
  null
  
)

export default component.exports